import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { twColorClass } from '@tran-monorepo/frontend/utils';
import { ContentWrapperComponent } from '../content-wrapper/content-wrapper.component';

@Component({
    selector: 'tran-ui-content-section',
    templateUrl: './content-section.component.html',
    imports: [ContentWrapperComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContentSectionComponent {
    public readonly backgroundImage = input<string>();
    public readonly backgroundPosition = input<string>('center center');
    public readonly backgroundColor = input<string>('deep-blue-900');
    public readonly minHeight = input<string>('auto');
    public readonly showOverlay = input<boolean>(false);
    public readonly overlayColor = input<string>('deep-blue-900');
    public readonly overlayOpacity = input<string>('60');
    public readonly noLeftSpacing = input<boolean>(false);
    public readonly noRightSpacing = input<boolean>(false);

    protected readonly overlayBackground = computed(
        () => `bg-${twColorClass(this.overlayColor(), this.overlayOpacity())}`
    );

    protected readonly backgroundColorClass = computed(() =>
        this.backgroundColor() ? `bg-${twColorClass(this.backgroundColor())}` : ''
    );
}
